// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__3Y_ii","middle":"Loader_middle__2Iy_d","card":"Loader_card__2g9SV"};